import { Flex } from "antd";
import { TurbineInfo } from "./Turbine";
import type { TurbineViewRenderProps } from "./TurbineViewRender";
import { ComponentsInfo } from "./Components";
import { WorkOrdersInfo } from "./WorkOrders";
import { WorkSummaryInfo } from "./WorkSummary";
import type { Dispatch } from "@reduxjs/toolkit";

type TurbineInformationProps = TurbineViewRenderProps & { dispatch: Dispatch };

export const TurbineInformation = (props: TurbineInformationProps) => {
  const { intl, turbineData, modalApi, currentRoute, dispatch } = props;
  return (
    <Flex vertical gap="middle">
      <TurbineInfo
        currentRoute={currentRoute}
        intl={intl}
        turbineData={turbineData}
        modalApi={modalApi}
      />
      <WorkSummaryInfo
        intl={intl}
        currentRoute={currentRoute}
        turbineData={turbineData}
        modalApi={modalApi}
      />
      <ComponentsInfo
        intl={intl}
        currentRoute={currentRoute}
        turbineData={turbineData}
        modalApi={modalApi}
      />
      <WorkOrdersInfo
        intl={intl}
        currentRoute={currentRoute}
        turbineData={turbineData}
        modalApi={modalApi}
        dispatch={dispatch}
      />
    </Flex>
  );
};
